export default __webpack_public_path__ + "media/images/celeste_key-5da7fd6370e18a24c8d170c5b197d22b.png";